import * as React from "react";
const SvgIndex = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12}
    height={14}
    fill="none"
    {...props}
  >
    <path
      stroke="#14181F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M3.25 2.333h3.833a2 2 0 0 1 2 2v5.334a2 2 0 0 1-2 2H3.25M2.667 8.75.917 7m0 0 1.75-1.75M.917 7H6.75"
    />
  </svg>
);
export default SvgIndex;